<script setup lang="ts">
/** TMP080 — Waiver of Preemption Rights. 실제 변수: letter_date, company_name, allottee loop, total_new_shares, Signers.
 *  토글: multiple_members, has_constitution. */
import { computed, inject } from 'vue';
import { OTC_DOC_CTX } from './otcContext';
import OtcDocVarField from './OtcDocVarField.vue';
import OtcAllotteeTable from './parts/OtcAllotteeTable.vue';
import OtcSigners from './parts/OtcSigners.vue';

const ctx = inject(OTC_DOC_CTX)!;
// 단수/복수 member 문구는 기존 주주 수로 자동계산(is_multiple_member) — Authority(members' resolution) 와 동일 flag 공유.
const multi = computed(() => ctx.flag('is_multiple_member'));
const we = computed(() => (multi.value ? 'We' : 'I'));
const our = computed(() => (multi.value ? 'our' : 'my'));
const us = computed(() => (multi.value ? 'us' : 'me'));
const hasConstitution = computed(() => ctx.flag('has_constitution'));
</script>

<template>
  <div class="allot-doc">
    <p class="doc-p"><b>Date :</b> <OtcDocVarField field-key="letter_date" /></p>
    <p class="doc-p">The Board of Directors<br /><OtcDocVarField field-key="company_name" /><br />Registered Office</p>
    <p class="doc-p">Dear Sirs,</p>
    <p class="doc-p"><b><u>Consent to waive pre-emption rights – Allotment of Shares</u></b></p>
    <p class="doc-p">
      <span class="doc-toggle" title="single / multiple member (auto from members)" @click="ctx.toggleFlag('is_multiple_member')">{{ we }}</span>,
      being the existing member{{ multi ? 's' : '' }} of <OtcDocVarField field-key="company_name" /> do hereby raise no
      objections to the allotment of shares as detailed below and consent to waive {{ our }} pre-emption rights accorded to {{ us }} under the
      <span class="doc-toggle" @click="ctx.toggleFlag('has_constitution')">{{ hasConstitution ? 'Constitution' : 'Articles of Association' }}</span>
      of the Company:-
    </p>

    <p class="doc-lbl-title">Non-Cash Allotment</p>
    <OtcAllotteeTable shares-header="No. of Share(s) Allotted" />

    <p class="doc-p" style="margin-top:22px">Yours faithfully,</p>
    <OtcSigners var-key="waiver" />
  </div>
</template>
